import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Press.css';

const pressArticles = [
  {
    id: 1,
    title: "Bharat's Enterprise AI Edge: Turning Complexity into Opportunity",
    date: "March 26, 2026",
    link: "/news/bharats-enterprise-ai-edge"
  },
  {
    id: 2,
    title: "Industrybull Appoints Animesh Srivastava as CTO",
    date: "March 12, 2026",
    link: "/news/industrybull-appoints-cto"
  },
  {
    id: 3,
    title: "AI in Supply Chains: Smarter Procurement and Planning",
    date: "March 12, 2026",
    link: "/news/ai-in-supply-chains"
  },
  {
    id: 4,
    title: "The Procurement Paradox: AI's Biggest Enterprise Opportunity",
    date: "February 27, 2026",
    link: "/news/the-procurement-paradox"
  },
  {
    id: 5,
    title: "India's Next Growth Phase: Manufacturing and Supply Chain Evolution",
    date: "February 15, 2026",
    link: "/news/indias-next-growth-phase"
  },
  {
    id: 6,
    title: "Industrybull Launches Cognilix, Expands into Enterprise AI",
    date: "January 15, 2026",
    link: "/news/industrybull-launches-cognilix"
  },
  {
    id: 7,
    title: "Rahul Garg on Building Industrybull and Scaling India's B2B Commerce",
    date: "December 30, 2025",
    link: "/news/rahul-garg-on-building-industrybull"
  },
  {
    id: 8,
    title: "Capability Over Cost: Shifting Global Supply Chains",
    date: "December 26, 2025",
    link: "/news/capability-over-cost"
  },
  {
    id: 9,
    title: "Balancing Growth with Reality: India's Manufacturing Trajectory",
    date: "December 15, 2025",
    link: "/news/balancing-growth-with-reality"
  },
  {
    id: 10,
    title: "PLI as a Catalyst: India's Manufacturing Momentum",
    date: "November 22, 2025",
    link: "/news/pli-as-a-catalyst"
  },
  {
    id: 11,
    title: "A More Distributed Trade Model: Building Resilient Global Supply Chains",
    date: "November 20, 2025",
    link: "/news/distributed-trade-model"
  },
  {
    id: 12,
    title: "Building Quietly at Scale: Industrybull's Journey to a $700 Mn B2B Marketplace",
    date: "October 21, 2025",
    link: "/news/building-quietly-at-scale"
  }
];

const Press: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="press-page">
      <div className="press-container">
        
        <div className="press-header">
          <h1 className="press-title">Industrybull in Media</h1>
          <p className="press-subtitle">
            Get The Latest Buzz. Interviews, Articles, and Media Coverages.
          </p>
        </div>

        <div className="press-grid">
          {pressArticles.map((article) => (
            <Link to={article.link} key={article.id} className="press-card">
              <div className="press-card__image-container">
                <span className="press-card__placeholder"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/></svg></span>
              </div>
              <div className="press-card__content">
                <div className="press-card__date">{article.date}</div>
                <h3 className="press-card__title">{article.title}</h3>
              </div>
            </Link>
          ))}
        </div>

        <div className="press-pagination">
          <button className="press-pagination__btn" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="press-pagination__icon">
              <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" fill="currentColor"/>
            </svg>
          </button>
          <button className="press-pagination__btn active">1</button>
          <button className="press-pagination__btn">2</button>
          <button className="press-pagination__btn">3</button>
          <button className="press-pagination__btn">4</button>
          <button className="press-pagination__btn">5</button>
          <button className="press-pagination__btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="press-pagination__icon">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" fill="currentColor"/>
            </svg>
          </button>
        </div>

      </div>
    </div>
  );
};

export default Press;
